import React from 'react'
import { path } from 'ramda'

// eslint-disable-next-line
const { works } = JSON.parse(window.__initialData__)
const filtered = works.filter(w => path(['images', 0, 'width'], w))

const converted = filtered.map((w) => {
  const { width, height } = w.images[0]
  return {
    ...w,
    videoRatio: (height / width) * 100,
  }
})

const WorkContext = React.createContext({ works: converted })

export default Component => props => (
  <WorkContext.Consumer>
    {worksData => <Component {...props} works={worksData.works} />}
  </WorkContext.Consumer>
)



// WEBPACK FOOTER //
// ./src/hoc/withWorks.js